import React from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import Image1 from "./../../assets/homepage_1_slider_1_item_1.jpg";
import Image2 from "./../../assets/homepage_1_slider_1_item_2.jpg";
import Image3 from "./../../assets/homepage_1_slider_1_item_3.jpg";
import TruckImage from "./../../assets/homepage_1_free_image.png";
import SupportImage from "./../../assets/homepage_1_support_image.png";
import ReturnImage from "./../../assets/homepage_1_return_image.png";
import PayoutImage from "./../../assets/homepage_1_payout_image.png";

const responsive = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 3000 },
    items: 1,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 1,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 1,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
  },
};
const Hero = () => {
  return (
    <div className="relative">
      <Carousel responsive={responsive} showDots={true}>
        <div className="h-[400px] md:h-screen relative">
          <img src={Image1} alt="" className="absolute h-[400px] md:h-screen object-cover" />
          <div className="absolute flex flex-col justify-center items-center w-full h-[400px] md:h-screen bg-black bg-opacity-65 p-5">
            <h1
              className="text-white font-rubik font-bold text-4xl"
              data-aos="zoom-in"
            >
              Batman Arkham Knight
            </h1>
            <p
              className="text-white font-rubik max-w-[600px] my-6"
              data-aos="zoom-in"
            >
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime
              assumenda maiores laboriosam consequuntur asperiores consectetur,
            </p>
            <button
              className="text-base font-rubik font-bold bg-primary p-3 px-10 rounded-full text-white"
              data-aos="zoom-in"
            >
              Shop Now
            </button>
          </div>
        </div>

        <div className="h-[400px] md:h-screen relative">
          <img src={Image2} alt="" className="absolute h-[400px] md:h-screen object-cover" />
          <div className="absolute flex flex-col justify-center w-full h-[400px] md:h-screen bg-black bg-opacity-65 p-8">
            <div>
              <h1
                className="text-white font-rubik font-bold text-4xl"
                data-aos="fade-left"
              >
                Forza Horizon 5
              </h1>
              <p
                className="text-white font-rubik max-w-[600px] my-6"
                data-aos="fade-left"
              >
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime
                assumenda maiores laboriosam consequuntur asperiores
                consectetur,
              </p>
              <button
                className="text-base font-rubik font-bold bg-primary w-auto p-3 px-10 rounded-full text-white"
                data-aos="fade-left"
              >
                Shop Now
              </button>
            </div>
          </div>
        </div>

        <div className="h-[400px] md:h-screen relative">
          <img src={Image3} alt="" className="absolute h-[400px] md:h-screen object-cover" />
          <div className="absolute flex flex-col justify-center w-full h-[400px] md:h-screen bg-black bg-opacity-65 p-8">
            <div>
              <h1
                className="text-white font-rubik font-bold text-4xl"
                data-aos="fade-left"
              >
                Titanfall 2
              </h1>
              <p
                className="text-white font-rubik max-w-[600px] my-6"
                data-aos="fade-left"
              >
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime
                assumenda maiores laboriosam consequuntur asperiores
                consectetur,
              </p>
              <button
                className="text-base font-rubik font-bold bg-primary w-auto p-3 px-10 rounded-full text-white"
                data-aos="fade-left"
              >
                Shop Now
              </button>
            </div>
          </div>
        </div>
      </Carousel>

      <div className="bg-[#e6e8f0] min-h-[150px] relative">
        <div className="flex flex-wrap justify-center md:justify-between w-full xl:absolute p-5 bottom-[10%] gap-5">
          <div className="bg-white p-5 flex flex-col justify-center items-center rounded-lg max-w-[320px]">
            <img src={TruckImage} alt="" />
            <p className="my-4 font-rubik font-bold text-lg">Free Shipping</p>
            <p className="text-center font-rubik text-sm text-[#979797] font-normal">
              Lorem Ipsum Dolor Sit Amet, Consectetur Adipiscing Elit, Sed Do
              Eiusmod
            </p>
          </div>

          <div className="bg-white p-5 flex flex-col justify-center items-center rounded-lg max-w-[320px]">
            <img src={SupportImage} alt="" />
            <p className="my-4 font-rubik font-bold text-lg">
              Online Support 24/7
            </p>
            <p className="text-center font-rubik text-sm text-[#979797] font-normal">
              Lorem Ipsum Dolor Sit Amet, Consectetur Adipiscing Elit, Sed Do
              Eiusmod
            </p>
          </div>

          <div className="bg-white p-5 flex flex-col justify-center items-center rounded-lg max-w-[320px]">
            <img src={ReturnImage} alt="" />
            <p className="my-4 font-rubik font-bold text-lg">Money Return</p>
            <p className="text-center font-rubik text-sm text-[#979797] font-normal">
              Lorem Ipsum Dolor Sit Amet, Consectetur Adipiscing Elit, Sed Do
              Eiusmod
            </p>
          </div>

          <div className="bg-white p-5 flex flex-col justify-center items-center rounded-lg max-w-[320px]">
            <img src={PayoutImage} alt="" />
            <p className="my-4 font-rubik font-bold text-lg">Secure Payment</p>
            <p className="text-center font-rubik text-sm text-[#979797] font-normal">
              Lorem Ipsum Dolor Sit Amet, Consectetur Adipiscing Elit, Sed Do
              Eiusmod
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
